export default "__VITE_ASSET__BPU_MRoV__"